var map = {
	"./clinic-01.jpg": 8496,
	"./clinic-02.jpg": 66836,
	"./doctor-profile-img.jpg": 28535,
	"./doctor-sidebar-bg.jpg": 6594,
	"./patient-sidebar-bg.jpg": 31233,
	"./profile-01.jpg": 75043,
	"./profile-02.jpg": 11641,
	"./profile-03.jpg": 18658,
	"./profile-04.jpg": 34765,
	"./profile-05.jpg": 87896,
	"./profile-06.jpg": 46791,
	"./profile-07.jpg": 76917,
	"./profile-08.jpg": 7561
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23956;